import React from "react";
import {addToCart, removeFromCart} from "../actions/cart";
import {setProductScope} from "../actions/products";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
                                                  
import {hasNoPrice} from "../helper/priceUtil";
import {SwiperSlide} from "swiper/react";
                                            
import "./ProductSwiperSlider.scss";
                                             
import {getTextColor} from "../helper/setTextColor";
import ShoppingBag from "./icons/ShoppingBag";
import ProductPrices from "./ProductPrices";
import {customHistory} from "../helper/history";

                                       
                     
                          
                        
                      
                
                              
                               
                                     
                 
                       
                        
 

const ProductSwiperSlide = (props                         ) => {
    const [overlay, setOverlay] = React.useState(false);
    const {
        product,
        setProductScope,
        addToCart,
        removeFromCart
    } = props;
    const handleAddToCart = () => {
        addToCart(props.t("navigation.maxBookmarksReached"));
        setOverlay(true);
    };
    const handleRemoveFromCart = () => {
        removeFromCart();
        setOverlay(false);
    };

    return <SwiperSlide className={"swiper-slide " + props.className} key={"_" + props.key}>
		<span className="pad pro pro-01" data-testid={"product-slide"}>
			<span>
				<button onClick={() => setProductScope(product)}
                        aria-label={product.galleryImage.previewImage?.caption || product.name}
                        className={"img toggle-detail " + (overlay ? "plopOverlay" : "")}
                        style={{backgroundImage: `url('${product.galleryImage.previewImage ? product.galleryImage.previewImage.attachmentUrl : product.galleryImage.attachmentUrl}')`}}
                        data-testid={"openProduct"}
                >
			        <span/>
			        <span style={{color: getTextColor()}}>{props.t("cart.add")}</span>
				</button>
				<span className="title" data-testid={"productTitle"}>{product.name}</span>
			</span>
			<span>
				<ProductPrices product={product} showMsrp={props.showMsrp} hidePrices={props.hidePrices}/>
				<span className="links">
					<button className="toggle-shop toggle-detail" data-testid={"productDetails"}
                            onClick={() => setProductScope(product)}>
						{props.t("navigation.details")}
					</button>
                    {!props.cartDisabled && (props.isSelected
                        ? <button className={"add toggle-card-add-01 productIsSelected"}
                                  onClick={() => handleRemoveFromCart()} data-testid={"removeProduct"}>
                            {props.t("navigation.remove")}
                            <ShoppingBag className={"shoppingBagafter"} fill={getTextColor()}/>
                        </button>
                        : <button className={"add toggle-card-add-01"} onClick={() => handleAddToCart()}
                                  data-testid={"addProduct"}>
                            {props.t("navigation.add")}
                            <ShoppingBag className={"shoppingBagbefore"}/>
                        </button>)
                    }
				</span>
			</span>
		</span>
    </SwiperSlide>;
};

function mapStateToProps(state                  , ownProps                         ) {
    return {
        cartDisabled: state.cart.cartDisabled,
        hidePrices: state.cart.hidePrices || hasNoPrice(ownProps.product),
        showMsrp: state.config.showMsrp,
        isSelected: state.cart.items.some(item => item.id === ownProps.product.id)
    };
}

function mapDispatchToProps(dispatch, ownProps                         ) {
    return {
        addToCart: (errorMsg        ) => dispatch(addToCart(ownProps.product, errorMsg)),
        removeFromCart: () => dispatch(removeFromCart(ownProps.product)),
        setProductScope: product => {
            dispatch(setProductScope(product));
            customHistory.push(`/product/${product.id}`);
        }
    };
}

ProductSwiperSlide.displayName = "SwiperSlide";
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ProductSwiperSlide));
